import React, {PropTypes} from 'react';
import {__} from '../../../server/lib/i18n-2/browserHelper'
import {formatMoneyNoCurrency} from'../../lib/utils'

console.log("__", __('companyBla'))


const Company = (props) => {
  const image =
    props.image && (
      <div className="left">
        <img className="header-img" src={props.thumb} alt="header image of a company"/>
      </div>
    )
    const price =
      props.priceVisibility && (
        <div className="col-sm-6 item">
          <div className="content text-style">
            <div className="header-text">{__('PŘEDPOKLÁDANÁ CENA')}:</div>
            <span className="light-blue">{formatMoneyNoCurrency(props.expectedPrice, props.lang)} {__('Kč')}</span>
          </div>
        </div>
      )
    const ebitda = props.EBITDANegative && (
      <span className="light-blue">Záporná</span>
    ) || (
      <span className="light-blue">{formatMoneyNoCurrency(props.EBITDAMin, props.lang)} až {formatMoneyNoCurrency(props.EBITDAMax, props.lang)} {__('Kč')}</span>
    )
return (
  <div className="item logged">
    <div className="content-section">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="content header-section align-left">
              {image}
              <div className="inline hdr header-2 header-text padded-light">{props.titlePublic}</div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6 long-text-section">
            <div className="simple-textbox-component" id="vyhody-textbox-top">
              <div className="item text-style dark-underlined-links">
                <div className="small-padding no-margin hdr header-3 header-text dark-grey align-left" style={{'fontFamily': 'Open Sans', 'letterSpacing': '-.5px'}}>{props.perex}</div>
                <div className="text-style align-left text-content" dangerouslySetInnerHTML={{__html: props.shortText}} />
              </div>
              <div className="content text-style">
                <div className="header-text">{__('PŘEDMĚT ČINNOSTI')}:</div>
                <div className="text-style align-left text-content">
                  {props.investorDesc}
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-6 text-section">
            <div className="container-fluid underlined-links">
              <div className="row">
                <div className="col-sm-6 item">
                  <div className="content text-style">
                    <div className="header-text">{__('TRŽBY')}:</div>
                    <span className="light-blue">{formatMoneyNoCurrency(props.salesMin, props.lang)} až {formatMoneyNoCurrency(props.salesMax, props.lang)} {__('Kč')}</span>
                  </div>
                </div>
                <div className="col-sm-6 item">
                  <div className="content text-style">
                    <div className="header-text">{__('AKTIVA')}:</div>
                    <span className="light-blue">{formatMoneyNoCurrency(props.assets, props.lang)} {__('Kč')}</span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 item">
                  <div className="content text-style">
                    <div className="header-text">{__('EBITDA')}:</div>
                    {ebitda}
                  </div>
                </div>
                {price}
              </div>
              <div className="row">
                <div className="col-sm-6 item">
                  <div className="content text-style">
                    <div className="header-text">{__('Obor')}:</div>
                    <div className="content tags">
                      {props.tags.map((t, k) => <a style={{display: 'block'}} key={k} href={t.absoluteUrl}>#{t.name}</a>)}
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 item">
                  <div className="content text-style">
                    <div className="header-text">{__('KATEGORIE')}:</div>
                    <div className="content category">
                      {props.categories.map((t, k) => <a style={{display: 'block'}} key={k} href={t.absoluteUrl}>{t.name}</a>)}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 item">
                  <div className="content text-style">
                    <div className="header-text inline margin-right">STATUS: </div>
                     {props.status && props.status.name}
                  </div>
                </div>
                <div className="col-sm-6 item">
                  <div className="content text-style">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="centered content after">
              <a href={props.absoluteUrl} className="btn-classic btn-wide btn-blue">{__('VÍCE INFORMACÍ')}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default Company



// WEBPACK FOOTER //
// ./src/browser/components/stateless/Company.react.js